<template>
    <div class="footer mt-5">
        <div class="container">
            <div class="row pb-4">
                <div class="col-md-3">
                    <h4 class="text-white">Mobile Apps</h4>
                    <p><a href="https://apps.apple.com/us/app/meterdog/id1370285192">iOS MeterDog</a></p>
                    <p><a href="https://apps.apple.com/us/app/levelsmart/id1437483236">iOS LevelSmart</a></p>
                    <p><a href="https://play.google.com/store/apps/details?id=com.tapcrew.meterdog&hl=en_US">Android MeterDog</a></p>
                    <p><a href="https://play.google.com/store/apps/details?id=com.tapcrew.levelsmart&hl=en_US">Android LevelSmart</a></p>
                </div>
                <div class="col-md-3">
                    <h4 class="text-white">Legal</h4>
                    <p><a href="https://www.konametrix.com/">Privacy</a></p>
                    <p><a href="https://www.konametrix.com/">Terms and Conditions</a></p>
                </div>
                <div class="col-md-3">
                    <h4 class="text-white">Support</h4>
                    <p><a href="https://www.konametrix.com/">Help Center</a></p>
                    <p><a href="https://www.konametrix.com/">Kona Blog</a></p>
                </div>
                <div class="col-md-3">
                    <h4 class="text-white">Connect</h4>
                    <p><a href="https://www.konametrix.com/">Facebook</a></p>
                    <p><a href="https://www.konametrix.com/">LinkedIn</a></p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3 mx-auto pt-5">
                    <p class="text-center"><img src="/logo.png" height="60"></p>
                    <p class="copyright text-center">© 2020 Kona Metrix. All Rights Reserved.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'k-footer-menu'
    }

</script>


